// Supabase tablolarına veri kaydetme ve yükleme servisi
import { supabase } from '../lib/supabase';

// ============================================
// FAVORİLER İŞLEMLERİ
// ============================================

// Favoriyi Supabase tablosuna kaydet
export const saveFavoriteToSupabase = async (movie, userId) => {
    if (!supabase || !userId) return false;

    try {
        const { error } = await supabase
            .from('user_favorites')
            .insert({
                user_id: userId,
                movie_id: movie.id || movie.originalId || String(movie.id || ''),
                movie_title: movie.title || '',
                movie_year: movie.year || null,
                movie_poster: movie.posterUrl || movie.poster || null,
                movie_genre: movie.genre || null,
                movie_description: movie.description || movie.explanation || null,
                content_type: movie.contentType || 'film'
            })
            .select()
            .single();

        if (error) {
            // Zaten varsa (UNIQUE constraint) hata verme
            if (error.code === '23505') {
                return true; // Zaten var, başarılı say
            }
            throw error;
        }

        return true;
    } catch (error) {
        console.error('❌ Supabase favori kaydetme hatası:', error);
        return false;
    }
};

// Favoriyi Supabase tablosundan sil
export const removeFavoriteFromSupabase = async (movieId, movieTitle, userId) => {
    if (!supabase || !userId) return false;

    try {
        const { error } = await supabase
            .from('user_favorites')
            .delete()
            .eq('user_id', userId)
            .or(`movie_id.eq.${movieId},movie_title.eq.${movieTitle || ''}`);

        if (error) throw error;
        return true;
    } catch (error) {
        console.error('❌ Supabase favori silme hatası:', error);
        return false;
    }
};

// Kullanıcının tüm favorilerini Supabase'den yükle
export const loadFavoritesFromSupabase = async (userId) => {
    if (!supabase || !userId) return [];

    try {
        const { data, error } = await supabase
            .from('user_favorites')
            .select('*')
            .eq('user_id', userId)
            .order('added_at', { ascending: false });

        if (error) throw error;

        // Supabase formatından localStorage formatına dönüştür
        return data.map(fav => ({
            id: fav.movie_id,
            originalId: fav.movie_id,
            title: fav.movie_title,
            year: fav.movie_year,
            posterUrl: fav.movie_poster,
            genre: fav.movie_genre,
            description: fav.movie_description,
            contentType: fav.content_type || 'film',
            addedToFavoritesAt: fav.added_at
        }));
    } catch (error) {
        console.error('❌ Supabase favorileri yükleme hatası:', error);
        return [];
    }
};

// ============================================
// İZLENENLER İŞLEMLERİ
// ============================================

// İzleneni Supabase tablosuna kaydet
export const saveWatchedToSupabase = async (movie, userId) => {
    if (!supabase || !userId) return false;

    try {
        const { error } = await supabase
            .from('user_watched')
            .insert({
                user_id: userId,
                movie_id: movie.id || movie.originalId || String(movie.id || ''),
                movie_title: movie.title || '',
                movie_year: movie.year || null,
                movie_poster: movie.posterUrl || movie.poster || null,
                movie_genre: movie.genre || null,
                movie_description: movie.description || movie.explanation || null,
                content_type: movie.contentType || 'film'
            })
            .select()
            .single();

        if (error) {
            // Zaten varsa (UNIQUE constraint) hata verme
            if (error.code === '23505') {
                return true; // Zaten var, başarılı say
            }
            throw error;
        }

        return true;
    } catch (error) {
        console.error('❌ Supabase izlenen kaydetme hatası:', error);
        return false;
    }
};

// İzleneni Supabase tablosundan sil
export const removeWatchedFromSupabase = async (movieId, userId) => {
    if (!supabase || !userId) return false;

    try {
        const { error } = await supabase
            .from('user_watched')
            .delete()
            .eq('user_id', userId)
            .eq('movie_id', movieId);

        if (error) throw error;
        return true;
    } catch (error) {
        console.error('❌ Supabase izlenen silme hatası:', error);
        return false;
    }
};

// Kullanıcının tüm izlenenlerini Supabase'den yükle
export const loadWatchedFromSupabase = async (userId) => {
    if (!supabase || !userId) return [];

    try {
        const { data, error } = await supabase
            .from('user_watched')
            .select('*')
            .eq('user_id', userId)
            .order('watched_at', { ascending: false });

        if (error) throw error;

        // Supabase formatından localStorage formatına dönüştür
        return data.map(watched => ({
            id: watched.movie_id,
            originalId: watched.movie_id,
            title: watched.movie_title,
            year: watched.movie_year,
            posterUrl: watched.movie_poster,
            genre: watched.movie_genre,
            description: watched.movie_description,
            contentType: watched.content_type || 'film',
            watchedAt: watched.watched_at
        }));
    } catch (error) {
        console.error('❌ Supabase izlenenleri yükleme hatası:', error);
        return [];
    }
};

// ============================================
// ÖNERİLER İŞLEMLERİ
// ============================================

// Öneriyi Supabase tablosuna kaydet
export const saveRecommendationToSupabase = async (recommendationData, userId) => {
    if (!supabase || !userId) return false;

    try {
        const { error } = await supabase
            .from('user_recommendations')
            .insert({
                user_id: userId,
                recommendation_data: recommendationData,
                content_type: recommendationData.contentType || 'film',
                origin: recommendationData.origin || 'yabancı'
            });

        if (error) throw error;

        // Öneri sayacını artır (kalıcı sayaç için)
        await incrementSuggestionCount();

        return true;
    } catch (error) {
        console.error('❌ Supabase öneri kaydetme hatası:', error);
        return false;
    }
};

// Tüm önerileri Supabase tablosuna kaydet (batch)
export const saveAllRecommendationsToSupabase = async (recommendations, userId) => {
    if (!supabase || !userId) return false;

    try {
        // Önce mevcut önerileri sil
        await supabase
            .from('user_recommendations')
            .delete()
            .eq('user_id', userId);

        // Yeni önerileri ekle
        if (recommendations.length > 0) {
            const recommendationsToInsert = recommendations.map(rec => ({
                user_id: userId,
                recommendation_data: rec,
                content_type: rec.contentType || rec.recommendations?.[0]?.contentType || 'film',
                origin: rec.origin || 'yabancı'
            }));

            const { error } = await supabase
                .from('user_recommendations')
                .insert(recommendationsToInsert);

            if (error) throw error;
        }

        return true;
    } catch (error) {
        console.error('❌ Supabase öneriler kaydetme hatası:', error);
        return false;
    }
};

// Öneriyi Supabase tablosundan sil
export const removeRecommendationFromSupabase = async (recommendationId, userId) => {
    if (!supabase || !userId) return false;

    try {
        const { error } = await supabase
            .from('user_recommendations')
            .delete()
            .eq('id', recommendationId)
            .eq('user_id', userId);

        if (error) throw error;
        return true;
    } catch (error) {
        console.error('❌ Supabase öneri silme hatası:', error);
        return false;
    }
};

// Kullanıcının tüm önerilerini Supabase'den yükle
export const loadRecommendationsFromSupabase = async (userId) => {
    if (!supabase || !userId) return [];

    try {
        const { data, error } = await supabase
            .from('user_recommendations')
            .select('*')
            .eq('user_id', userId)
            .order('created_at', { ascending: false });

        if (error) throw error;

        // Supabase formatından localStorage formatına dönüştür
        return data.map(rec => ({
            ...rec.recommendation_data,
            id: rec.id, // Supabase ID'sini ekle
            createdAt: rec.created_at
        }));
    } catch (error) {
        console.error('❌ Supabase önerileri yükleme hatası:', error);
        return [];
    }
};

// ============================================
// İSTATİSTİKLER
// ============================================

// Öneri sayacını user_stats tablosundan al (kalıcı - F5 ile uçmaz)
export const getMySuggestionCount = async () => {
    if (!supabase) return 0;

    try {
        const { data, error } = await supabase
            .from('user_stats')
            .select('suggestion_count')
            .single(); // RLS nedeniyle sadece kendi satırın gelir

        if (error && error.code !== 'PGRST116') { // PGRST116 = no rows returned
            console.error('❌ Öneri sayacı yükleme hatası:', error);
            return 0;
        }

        return data?.suggestion_count ?? 0;
    } catch (error) {
        console.error('❌ Öneri sayacı yükleme hatası:', error);
        return 0;
    }
};

// Gerçek öneri sayısını Supabase'den al (tam sayı, localStorage'a bağlı değil)
export const getRecommendationCountExact = async () => {
    if (!supabase) return 0;

    try {
        // Önce user_recommendations tablosundan gerçek kayıt sayısını al
        // Bu, gerçek öneri sayısını gösterir
        const { count, error } = await supabase
            .from('user_recommendations')
            .select('*', { count: 'exact', head: true });

        if (error) {
            console.error('❌ Öneri sayısı kontrolü hatası:', error);
            // Hata durumunda user_stats'tan oku (fallback)
            const statsCount = await getMySuggestionCount();
            return statsCount;
        }

        // user_recommendations tablosundaki gerçek kayıt sayısını döndür
        // Bu, kaç öneri seansı yapıldığını gösterir (her seans = 1 kayıt)
        const actualCount = count ?? 0;

        // Eğer stats ile fark varsa, stats'ı da güncelle (senkronizasyon için)
        const statsCount = await getMySuggestionCount();
        if (actualCount !== statsCount && actualCount > 0) {
            // Senkronizasyon gerekebilir (sessizce devam et)
        }

        return actualCount;
    } catch (error) {
        console.error('❌ getRecommendationCountExact hatası:', error);
        // Fallback: user_stats'tan oku
        try {
            return await getMySuggestionCount();
        } catch {
            return 0;
        }
    }
};

// Öneri sayacını artır (RPC çağrısı) - Güvenli versiyon (çoklu çağrıları önler)
let incrementInProgress = false;
export const incrementSuggestionCount = async () => {
    if (!supabase) return false;

    // Çoklu çağrıları önle - eğer zaten bir artırma işlemi devam ediyorsa bekle
    if (incrementInProgress) {
        console.warn('⚠️ Öneri sayacı artırma işlemi zaten devam ediyor, yeni çağrı engellendi');
        return false;
    }

    incrementInProgress = true;

    try {
        const { error } = await supabase.rpc('increment_suggestion_count');
        if (error) throw error;
        return true;
    } catch (error) {
        console.error('❌ Öneri sayacı artırma hatası:', error);
        return false;
    } finally {
        // Kısa bir gecikme sonrası flag'i sıfırla (race condition önleme)
        setTimeout(() => {
            incrementInProgress = false;
        }, 1000);
    }
};

// Kullanıcı istatistiklerini Supabase tablolarından al
export const getUserStatsFromSupabase = async (userId) => {
    if (!supabase || !userId) return null;

    try {
        // Paralel sorgular
        const [favoritesResult, watchedResult, recommendationsResult, statsResult] = await Promise.all([
            supabase
                .from('user_favorites')
                .select('id', { count: 'exact', head: true })
                .eq('user_id', userId),
            supabase
                .from('user_watched')
                .select('id', { count: 'exact', head: true })
                .eq('user_id', userId),
            supabase
                .from('user_recommendations')
                .select('id', { count: 'exact', head: true })
                .eq('user_id', userId),
            supabase
                .from('user_stats')
                .select('suggestion_count')
                .eq('user_id', userId)
                .single()
        ]);

        // Bu ay izlenenleri hesapla
        const thisMonth = new Date();
        thisMonth.setDate(1); // Ayın ilk günü
        thisMonth.setHours(0, 0, 0, 0);

        const { count: watchedThisMonth } = await supabase
            .from('user_watched')
            .select('id', { count: 'exact', head: true })
            .eq('user_id', userId)
            .gte('watched_at', thisMonth.toISOString());

        // En çok sevilen türleri hesapla
        const { data: favoritesData } = await supabase
            .from('user_favorites')
            .select('movie_genre')
            .eq('user_id', userId)
            .not('movie_genre', 'is', null);

        const genreCount = {};
        favoritesData?.forEach(fav => {
            if (fav.movie_genre) {
                genreCount[fav.movie_genre] = (genreCount[fav.movie_genre] || 0) + 1;
            }
        });

        const favoriteGenres = Object.entries(genreCount)
            .sort(([, a], [, b]) => b - a)
            .slice(0, 3)
            .map(([genre, count]) => ({ genre, count }));

        return {
            totalFavorites: favoritesResult.count || 0,
            totalWatched: watchedResult.count || 0,
            totalRecommendations: recommendationsResult.count || 0,
            suggestionCount: statsResult.data?.suggestion_count || 0, // Kalıcı sayaç
            watchedThisMonth: watchedThisMonth || 0,
            favoriteGenres
        };
    } catch (error) {
        console.error('❌ Supabase istatistik hatası:', error);
        return null;
    }
};

